import Vue from 'vue'
import AgGridColumnMethodMixins from '@/Mixins/SigmaClientNew/AgGridColumnMethods'

// Builds the Trans # cell content (a clickable link, or plain text). Shared by
// both the master grid and the dc_lines detail grid.
const buildTransGui = (row, useType) => {
  if (!row) return document.createTextNode('--')

  const ledger = row.transaction_ledger
    ? row.transaction_ledger.split(' ')[0]
    : '--'
  // Parent rows navigate by transaction_src; DC line rows by transaction_type.
  const src = row.transaction_type
  if (src !== 'PT' && src !== 'CK') {
    const routeMap = {
      AP: 'aps',
      AR: 'ars',
      RT: 'rts',
      PC: 'pettycash',
      CC: 'ccs',
      JE: 'jes',
      PR: 'prs',
      PO: 'pos'
    }
    const routeName = routeMap[src]
    if (!routeName) return document.createTextNode(ledger)
    const link = document.createElement('a')
    link.href = `/${routeName}/${row.transaction_id}`
    link.target = '_blank'
    link.style.color = '#409EFF'
    link.style.textDecoration = 'none'
    link.textContent = ledger
    return link
  }
  return document.createTextNode(ledger)
}

// A proper cell renderer component. Unlike a bare function, this works both as a
// column cellRenderer and as the innerRenderer of agGroupCellRenderer (master rows).
export class TransLinkCellRenderer {
  init (params) {
    this.eGui = document.createElement('span')
    this.eGui.appendChild(buildTransGui(params.data, params.useType))
  }
  getGui () {
    return this.eGui
  }
  refresh () {
    return false
  }
}

export default Vue.extend({
  mixins: [AgGridColumnMethodMixins],

  data () {
    return {
      searchIdColumn: {
        headerName: 'Trans #',
        field: 'transaction_ledger',
        width: 180,
        cellRenderer: TransLinkCellRenderer
      },

      searchSrcColumn: {
        headerName: 'Type',
        field: 'transaction_src',
        width: 100
        // valueGetter: ({ data }) =>
        //   data && data.transaction_src === 'DC' ? data.transaction_type : data.transaction_src
      },

      searchVendorColumn: {
        headerName: 'Vendor',
        field: 'transaction_vendor',
        minWidth: 150,
        valueGetter: ({ data }) =>
          data && data.transaction_vendor ||
          data && data.transaction_third_party_vendor ||
          '--'
      },

      searchDocColumn: {
        headerName: 'Doc #',
        field: 'transaction_number',
        width: 150
      },
      searchPaymentColumn: {
        headerName: 'Payment #',
        field: 'transaction_payment_number',
        valueGetter: ({ data }) =>
          data && data.transaction_payment_number ||
          '--',
        width: 120
      },

      searchEffectiveDateColumn: {
        headerName: 'Date',
        field: 'transaction_date',
        width: 120,
        valueFormatter: ({ value }) => {
          if (value) {
            const dt = value.split('-')
            return dt[1] + '-' + dt[2] + '-' + dt[0]
          } else {
            return '-'
          }
        }
      },

      searchPOColumn: {
        headerName: 'PO #',
        field: 'PO_reference',
        minWidth: 130,
        valueGetter: ({ data }) =>
          data && data.PO_number || data && data.PO_reference || '--'
      },

      searchAccountColumn: {
        headerName: 'Account',
        field: 'account',
        minWidth: 120
      },

      searchAmountColumn: {
        headerName: 'Amount',
        field: 'amount',
        colId: 'amount',
        flex: 1,
        minWidth: 120,
        cellStyle: { textAlign: 'right' },
        valueFormatter: ({ value }) =>
          this.intlNumberFormatter(value)
      },

      searchDescriptionColumn: {
        headerName: 'Description',
        field: 'description',
        minWidth: 180,
        tooltipField: 'description',
        tooltipValueGetter: ({ value }) => value || ''
      },

      searchStatusColumn: {
        headerName: 'Status',
        field: 'transaction_status',
        minWidth: 60
      },

      searchCreatedByColumn: {
        headerName: 'Created By',
        field: 'created_by',
        width: 80
      },

      searchPostingDateColumn: {
        headerName: 'Posting Date',
        field: 'transaction_posting_date',
        width: 140,
        valueFormatter: ({ value }) => {
          if (value) {
            const dt = value.split('-')
            return dt[1] + '-' + dt[2] + '-' + dt[0]
          } else {
            return '-'
          }
        }
      },

      // searchModifiedByColumn: {
      //   headerName: 'Last Modified By',
      //   field: 'transaction_modified_by',
      //   width: 80
      // },

      searchModificationDateColumn: {
        headerName: 'Modification Date',
        field: 'transaction_modification_date',
        width: 160,
        valueFormatter: ({ value }) => {
          if (value) {
            const dt = value.split('-')
            return dt[1] + '-' + dt[2] + '-' + dt[0]
          } else {
            return '-'
          }
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/Mixins/SigmaClientNew/AgGridSearchResultColumns.js